import styled from "@emotion/styled";
import { SecondaryText } from "@silvertours/front-shared";
var Section = /*#__PURE__*/ styled("section", {
    target: "ew8k6qo0"
})("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[90];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[100];
}, ";}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[110];
}, ";}");
var Offers = /*#__PURE__*/ styled("ul", {
    target: "ew8k6qo1"
})("display:grid;scroll-snap-type:x mandatory;grid-template-columns:repeat(3,minmax(282px,396px));gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";overflow-x:auto;padding:", function(param) {
    var hasTitle = param.hasTitle, theme = param.theme;
    return "".concat(hasTitle ? 0 : theme.spacing[60], " 2rem ").concat(theme.spacing[60], " 2rem");
}, ";margin-left:-2rem;margin-right:-2rem;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{margin-left:-4rem;margin-right:-4rem;padding-left:4rem;padding-right:4rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-left:0;margin-right:0;padding-left:0;padding-right:0;overflow-x:visible;}");
var Offer = /*#__PURE__*/ styled("li", {
    target: "ew8k6qo2"
})("scroll-snap-align:center;");
var DisclaimerText = /*#__PURE__*/ styled(SecondaryText, {
    target: "ew8k6qo3"
})("text-align:center;");
var OverlayLink = /*#__PURE__*/ styled("button", {
    target: "ew8k6qo4"
})("display:inline-block;margin:0;padding:0;border:0;color:inherit;background-color:transparent;text-decoration:underline;cursor:pointer;&:hover,&:focus{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";}");
export { DisclaimerText, Offer, Offers, OverlayLink, Section };
